import { LevelRange } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import { User } from "@/store/modules/user/types";

export interface RootState {
  version: string;
  user?: { data: User };
  patients?: { data: Array<Patient> };
  route?: any;
}

export interface LabConfig {
  class?: string;
  title: string;
  atom: string;
  popupName: string;
  risk?: string;
}

export const enum LocationType {
  replace = "replace",
  fullscreen = "fullscreen"
}

export interface PopupDescription {
  component: string;
  location: LocationType;
  popupConfig?: PopupConfig;
}

export interface GraphRange {
  text: string;
  hours: number;
}

export interface PopupConfig {
  title?: string;
  graphs?: Array<GraphOptions>;
  segments?: Array<SegmentOptions>;
  graphRanges?: Array<GraphRange>;
  graphStartingIndex?: number;
  data?: any;
}

export interface SegmentOptions {
  title?: string;
  primary: string;
  secondary: string;
}

export interface GraphOptions {
  title?: string;
  source: string;
  component?: string;
}

export interface Review {
  active: number;
  sequence: number;
  status: number;
}

export interface Atom {
  time: string;
  review?: Review;
  alert: string;
  level: LevelRange;
  legend: string;
  value: number;
  age: number;
}

export interface Staff {
  autoFill: string;
  role: string;
  userID: string;
  userName: string;
  pager: string;
  phone: string;
  mode: string;
}

export interface Alert {
  id: string;
  icon: string;
  link: string;
  slot: number;
  level: number;
  message: string;
  audioMessage: string;
  room: string;
  atom: string;
  pickID: string;
  timeActive: string;
  reviewStatus: number;
}

export interface CaseState {
  state: number;
  stage: number;
  label: string;
  abbrev: string;
  color: string;
}

export interface RiskFactor {
  display: string;
  name: string;
  part: string;
  segment: string;
  type: string;
  weight: number;
}

export interface Reference {
  part: string;
  name: string;
  category: string;
  type: string;
  title: string;
  fileName: string;
  summary: string;
}

export interface VarLevel {
  category: string;
  variable: string;
  title: string;
  level1: number;
  level2: number;
  level3: number;
  level4: number;
  invert: boolean;
  [key: string]: string | number | boolean;
  unit: string;
}
